class OrderCreateTabsController {

    constructor($window, basket, guestnameService, itemService, loadingService) {
        this.$window = $window;
        this.basket = basket;
        this.guestnameService = guestnameService;
        this.itemService = itemService;
        this.loadingService = loadingService;
    }

    canShow (param) {
        const basketHasGuests = !!(this.basket
            && this.basket.contents
            && this.basket.contents.guest_details
            && this.basket.contents.guest_details.length > 0);

        switch (param) {
            case 'select-item':
                return !this.loadingService.isLoading('events');
            case 'guests':
                return !!(this.itemService.hasItem()
                    && this.itemService.getItem().quantity !== undefined);
                break;
            case 'suggestions':
                return !!(this.basket
                    && this.basket.contents
                    && this.basket.contents.has_suggestions);
            case 'review':
                return basketHasGuests;
            case 'payment':
                return !!this.order;
            case 'next-actions':
                return !!(basketHasGuests
                    && (!this.guests
                        || (this.guests
                            && this.guests.length === 0)));
            case 'final-actions':
                return !!(basketHasGuests
                    && this.order
                    && this.order.payment_details.length > 0);
        }

        return false;
    }

    scrollTo (param) {
        const element = this.$window.document.getElementById(param);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
}

OrderCreateTabsController.$inject = ['$window', 'basket', 'guestnameService', 'itemService', 'loadingService'];

export default OrderCreateTabsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/orderCreation/controllers/order.create.tabs.controller.js